// extracted by mini-css-extract-plugin
export default {"cont":"Pagination_cont__ll2AV","num":"Pagination_num__tdP91","active":"Pagination_active__kJvg3"};